import { ENetworkRequestStatus } from "services/BackendApi";

export enum RequestOtpResponseMessages {
  EMAIL_NOT_FOUND = 'Email not found',
  ALREADY_REQUESTED = 'Already requested',
}
export enum VerifyOtpResponseMessages {
  INVALID_OTP = 'Invalid OTP',
}

export interface IOtpSubdomain {
  form: {
    email: string;
    otp: string;
  },
  resendTimer: number;
  requests: {
    sendEmail: {
      statusCode: number | null;
      request: ENetworkRequestStatus;
      errors: string[] | null;
    },
    verifyOtp: {
      statusCode: number | null;
      request: ENetworkRequestStatus;
      errors: string[] | null;
    },
  }
};
export const initialState: IOtpSubdomain = {
  form: {
    email: '',
    otp: '',
  },
  resendTimer: Date.now(),
  requests: {
    sendEmail: {
      statusCode: null,
      request: ENetworkRequestStatus.IDLE,
      errors: null,
    },
    verifyOtp: {
      statusCode: null,
      request: ENetworkRequestStatus.IDLE,
      errors: null,
    },
  },
}